import { CardComposer, Row } from "@app/components";
import SvgArrowDown from "@app/components/icons/SvgArrowDown";
import { SvgTransferBack } from "@app/components/icons/SvgTransferBack";
import { theme } from "@app/theme";
import { ICatalogToProduct } from "@app/common/src/interfaces/catalog/catalog-to-product.interface";
import { memo, useState } from "react";
import { CatalogProductToProductVariationForm } from "./CatalogProductToProductVariationForm";
import { useFieldArray } from "react-hook-form";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import SvgDragAndDrop from "@app/components/icons/SvgDragAndDrop";
interface CatalogToCatalogProductProps {
  id: string;
  name: string;
  catalogToProduct: ICatalogToProduct;
  onRemove: () => void;
}

export const CatalogToCatalogProduct = memo(({ id, catalogToProduct, name, onRemove }: CatalogToCatalogProductProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { fields } = useFieldArray({
    name: `${name}.catalogProductToProductVariations`,
  });

  const tagsAsString = (catalogToProduct?.product?.tags || []).map(tag => tag.name).join(', ');

  const {
    setNodeRef,
    transform,
    transition,
    isDragging,
    attributes,
    listeners
  } = useSortable({
    id: id,
  });

  const style = {
    transform: CSS.Transform.toString({ ...transform!, scaleX: 1, scaleY: 1 }),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  if (!isOpen) {
    return (
      <CardComposer.SelectedItem ref={setNodeRef} extraStyle={style}>

        <CardComposer.SelectedItemTrigger onPress={() => setIsOpen(true)}>

          <Row align='center'>
            <CardComposer.SelectedItemIcon onPress={() => onRemove()}>
              <SvgTransferBack color={theme.colors.babypowder} />
            </CardComposer.SelectedItemIcon>
            <CardComposer.SelectedItemName>{catalogToProduct.product.name}</CardComposer.SelectedItemName>
          </Row>

          <Row align='center'>
            <CardComposer.SelectedItemCategory>{tagsAsString}</CardComposer.SelectedItemCategory>
            <CardComposer.SelectedItemDivider />

            <SvgDragAndDrop
              color="#fff"
              {...listeners}
              {...attributes}
              style={{ cursor: isDragging ? "grabbing" : "grab" }} />

            <CardComposer.SelectedItemDivider />

            <CardComposer.SelectedItemIcon onPress={() => setIsOpen(true)}>
              <SvgArrowDown color={theme.colors.babypowder} />
            </CardComposer.SelectedItemIcon>
          </Row>

        </CardComposer.SelectedItemTrigger>

        <CardComposer.SelectedItemDropdown />

      </CardComposer.SelectedItem>
    )
  }

  return (
    <CardComposer.SelectedItem ref={setNodeRef} extraStyle={style}>

      <CardComposer.SelectedItemTrigger isOpen onPress={() => setIsOpen(false)}>

        <Row align='center'>
          <CardComposer.SelectedItemIcon onPress={() => onRemove()}>
            <SvgTransferBack color={theme.colors.babypowder} />
          </CardComposer.SelectedItemIcon>
          <CardComposer.SelectedItemName isOpen>{catalogToProduct.product.name}</CardComposer.SelectedItemName>
        </Row>

        <Row align='center'>
          <CardComposer.SelectedItemCategory>{tagsAsString}</CardComposer.SelectedItemCategory>
          <CardComposer.SelectedItemDivider />

          <SvgDragAndDrop
            color="#fff"
            {...listeners}
            {...attributes}
            style={{ cursor: isDragging ? "grabbing" : "grab" }} />

          <CardComposer.SelectedItemDivider />

          <CardComposer.SelectedItemIcon onPress={() => setIsOpen(false)}>
            <SvgArrowDown color={theme.colors.babypowder} />
          </CardComposer.SelectedItemIcon>
        </Row>

      </CardComposer.SelectedItemTrigger>

      <CardComposer.SelectedItemDropdown isOpen>

        <CardComposer.DropdownHeader>
          <CardComposer.DropdownHeaderName>Déclinaison</CardComposer.DropdownHeaderName>
          <CardComposer.DropdownHeaderItem>Base</CardComposer.DropdownHeaderItem>
          <CardComposer.DropdownHeaderItem>Livraison</CardComposer.DropdownHeaderItem>
          <CardComposer.DropdownHeaderItem>Emporter</CardComposer.DropdownHeaderItem>
          <CardComposer.DropdownHeaderItem>Sur place</CardComposer.DropdownHeaderItem>
          <CardComposer.DropdownHeaderItem>Actif</CardComposer.DropdownHeaderItem>
        </CardComposer.DropdownHeader>

        {(fields as unknown as (ICatalogToProduct['catalogProductToProductVariations'][number] & { id: string })[]).map((field, index: number) => {
          return (
            <CatalogProductToProductVariationForm
              key={field.id}
              name={`${name}.catalogProductToProductVariations.${index}`}
              productVariation={field.productVariation} />
          )
        })}

      </CardComposer.SelectedItemDropdown>

    </CardComposer.SelectedItem>
  )
})